import { jsx as o } from "react/jsx-runtime";
import { AccordionSummary as c } from "./styles76.mjs";
import { ExpandMoreRounded as a } from "@mui/icons-material";
const i = ({
  testId: r,
  ...m
}) => /* @__PURE__ */ o(
  c,
  {
    expandIcon: /* @__PURE__ */ o(a, { color: "action" }),
    "data-testid": r,
    ...m
  }
);
export {
  i as AccordionSummary
};
//# sourceMappingURL=index110.mjs.map
